/**
 * File for internationalization
 *
 * @author   pablo.barco
 * @date     2020-06-29
 *
 * @copyright 2020 Smartmatic Corp. All Rights Reserved.
 *
 * @license
 *
 * Confidential information of Smartmatic Labs. Not for disclosure or
 * distribution prior written consent. This software contains code, techniques
 * and know-how which is confidential and proprietary to Smartmatic.
 *
 * Use of this software is subject to the terms of an end user license
 * agreement.
 */

import Axios from "axios";
import getEnv from "../utils/env";

// import en from './en.json'
// import es from './es.json'

export function retrieveLanguages(callback) {
  Axios.get(`${getEnv("VUE_APP_API_URL")}i18n/messages/DATACOL`).then(
    (response) => {
      const messages = response.data;
      for (let i = 0; i < messages.length; i++) {
        languages.push(messages[i]);
        languageNames.push({
          key: messages[i].language,
          value: messages[i].languageName,
        });
      }
      if (callback) {
        callback();
      }
    }
  );
}

export const languages = [];

export const languageNames = [];
